import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IconContext } from "react-icons";

import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
// import MuiButton from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { AuthService } from "../utils/redux/Auth/AuthService";
// import Stack from "@mui/material/Stack";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";

import { CgMenuLeftAlt as MenuIcon } from "react-icons/cg";

// import { defaultUser } from "../data/AuthUser";
// import UserAvatar from "./common/UserAvatar";

import { theme } from "../context/ThemeProvider";
// import { logout } from "../redux/actions/AuthActions";

function Header(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // get url from the current page
  const currentPage = window.location.pathname;

  // Extract main and sub sections from URL  // Extract main and sub sections from URL
  const getPathSections = (path) => {
    // Remove leading slash and split path into segments
    const segments = path.replace(/^\//, "").split("/");

    // Handle root dashboard path
    if (segments[0] === "dashboard" && segments.length === 1) {
      return { main: "Dashboard", sub: "" };
    }

    // Handle other dashboard paths
    if (segments[0] === "dashboard" && segments.length > 1) {
      // Convert kebab-case to title case for main section
      const main = segments[1]
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      // Get the last segment for sub section
      const lastSegment = segments[segments.length - 1];
      let sub = lastSegment
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      // Check if the last segment is a number
      if (!isNaN(lastSegment)) {
        // If it is a number, get the preceding segment as the sub-section
        sub = segments[segments.length - 2]
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }

      return { main, sub };
    }

    return { main: "", sub: "" };
  };

  const { main, sub } = getPathSections(currentPage);
  console.log("Main Section:", main); // "Agency Management"
  console.log("Sub Section:", sub); // "Downline"
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const toggleProfileMenu = (show) => (event) => {
    if (show) {
      setAnchorEl(event.currentTarget);
    } else {
      setAnchorEl(null);
    }
  };

  const handleLogout = async (event) => {
    try {
      const tokenData = JSON.parse(localStorage.getItem("user_profile") || "null");
      if (tokenData?.accessToken) {
        await AuthService.auth().Logout(
          { refreshToken: tokenData?.refreshToken },
          tokenData.accessToken
        );
      }
    } catch (error) {
      console.error("Logout request failed:", error);
    }
    localStorage.clear();
    navigate("/");
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar position="relative" elevation={1} color="secondary">
        <Toolbar
          sx={{
            display: "flex",
            // flexDirection: "row-reverse",
            justifyContent: "space-between",
          }}
        >
          <div className="flex items-center gap-2">
            <span className="icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                  stroke="#0E156F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                  stroke="#0E156F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="label">
              {main} {sub ? "/" : ""}{" "}
            </span>
            <span className="text-[#0E156F]">{sub}</span>
          </div>

          <div
            onClick={handleLogout}
            className="flex items-center gap-2 cursor-pointer"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
                stroke="#25233A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16 17L21 12L16 7"
                stroke="#25233A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21 12H9"
                stroke="#25233A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="text-[#25233A] text-[14px] font-[500]">
              Logout
            </span>
          </div>

          <IconContext.Provider
            value={{ size: "28px", color: `${theme.palette.primary.main}` }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={props.toggler}
              sx={{ ml: -1, display: { md: "none" } }}
            >
              <MenuIcon />
            </IconButton>
          </IconContext.Provider>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
}

export default Header;
